import Admin from './en/Admin.json';
import Auth from './en/Auth.json';
import common from './en/common.json';
import Containers from './en/Containers.json';
import CornerDialog from './en/CornerDialog.json';
import Project from './en/Project.json';
import ProjectView from './en/ProjectView.json';
import Team from './en/Team.json';
import Templates from './en/Templates.json';

const resources = {
  Admin,
  Auth,
  Containers,
  CornerDialog,
  Project,
  ProjectView,
  Team,
  Templates,
  common,
} as const;

export default resources;
